// src/components/store/sections/faqs/FaqV60TwocolumnboxIndigoPulse.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV60TwocolumnboxIndigoPulse(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={60}
      archKey="two_column_box"
      archLabel="Two-Column Split Grid"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      hexCol="#6366f1"
      {...props}
    />
  );
}
